export default {
  total: 'Total',
  buttons: {
    add_items: 'Add items',
  },
};
